import { render, staticRenderFns } from "./ProfileManager.vue?vue&type=template&id=f5d2782e&scoped=true"
import script from "./ProfileManager.vue?vue&type=script&lang=js"
export * from "./ProfileManager.vue?vue&type=script&lang=js"
import style0 from "./ProfileManager.vue?vue&type=style&index=0&id=f5d2782e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d2782e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VProgressCircular,VSwitch})
